export const testimonials = [
  {
    name: '林一舟',
    role: '长期读者 · 上海',
    content:
      '以前刷到一条热点，过两天就找不到后续了。看料社把时间线放在一起，隔一周回来还能接着看，这是我最喜欢的地方。',
  },
  {
    name: '周敏',
    role: '内容从业者 · 成都',
    content:
      '做选题的时候会先来这里对一下时间线，因为它会标清楚哪些是官方口径、哪些只是流传，省了很多核对成本。',
  },
  {
    name: '陈屿',
    role: '音乐节常客 · 广州',
    content:
      '开票规则一变我就能看到更新提醒，尤其是退票窗口这种细节，真的挺实用，不用再去翻十几条动态。',
  },
];

export const principles = [
  {
    title: '来源优先',
    desc: '只记录有明确发布主体的内容，未核实的流传信息会单独标注来源状态。',
    icon: 'ri-shield-check-line',
  },
  {
    title: '时间线完整',
    desc: '同一条线索的每一次更新都追加在同一页，不覆盖、不删除历史节点。',
    icon: 'ri-history-line',
  },
  {
    title: '不做推定',
    desc: '只呈现已公开的信息与回应，不替任何一方下结论，也不放大未经证实的说法。',
    icon: 'ri-scales-3-line',
  },
  {
    title: '持续归档',
    desc: '确认无后续的线索会标记归档，保留全部节点，方便后来查证完整过程。',
    icon: 'ri-archive-2-line',
  },
];